import * as $ from "jquery";
import * as _ from "lodash";
import * as Packery from "packery";
import { BaseDashboardCategoryLayout, BaseDashboardCategoryLayoutOptions } from "./_BaseDashboardCategoryLayout";
const Draggabilly = require('draggabilly');

declare var App;

// Get JSON-friendly data for items positions
(<any>Packery).prototype['getShiftPositions'] = function (layout: DashboardPackeryLayout, attrName) {
    attrName = attrName || 'id';
    var me = this;
    return this.items.map(function (item) {
        return {
            attr: item.element.getAttribute(attrName),
            x: layout.getColumnIndexFromApproxPercentage(item.rect.x / me.packer.width)
        }
    });
};

(<any>Packery).prototype['initShiftLayout'] = function (layout: DashboardPackeryLayout, positions, attr) {
    if (!positions || !positions.length) {
        // If no initial positions, run packery layout
        this.layout();
        return;
    }
    // Parse string to JSON
    if (typeof positions == 'string') {
        try {
            positions = JSON.parse(positions);
        } catch (error) {
            console.error('JSON parse error: ' + error);
            this.layout();
            return;
        }
    }

    attr = attr || 'id'; // Default to id attribute
    this._resetLayout();

    // Find items for which we don't have any position
    var unpositioned = _.filter(this.items, (item: any) => {
        return !_.find(positions, {attr: $(<string> item.element).attr(attr)});
    });

    // Set item order and horizontal position from saved positions
    var columns = layout.getNumberOfColumns();
    this.items = positions.map(function (itemPosition) {
        var selector = '[' + attr + '="' + itemPosition.attr + '"]';
        var $itemElem = layout.$(selector);
        var itemElem = $itemElem.get(0);

        // Determine the horizontal size of the widget
        var x;
        for (var i = 1; i < 7; i++) {
            if ($itemElem.hasClass('widget-w-' + i)) {
                x = i;
                break;
            }
        }

        if(!x) x = 1; // This should never be the case, but just in case a widget was not assigned a width

        // Adjust the x position by the horizontal size so that maximally right hand side of the widget
        // is bounded by the right edge of the screen
        x = Math.max(Math.min(columns - x, itemPosition.x), 0);

        var item = this.getItem(itemElem);
        if (item) {
            item.rect.x = (this.packer.width / columns) * x;
            return item;
        }
        return null
    }, this).filter(function (e) {
        return e !== null
    });

    // Add unpositioned items back to all items and layout
    this.items = this.items.concat(unpositioned);
    this._layoutItems(unpositioned, true);
    this.shiftLayout();

    // if not all the items had a position we may want to trigger a save
    return unpositioned;
};

// There is some kind of bug in Packery that causes the 'dragItemPositioned' event not to be fired, because it thinks
// there are still some items performing a layout.
// Since we don't care exactly about the timing, we simply fire our own 'dragEnd' event, which always fires when an item
// is positioned
var oldItemDragEnd = (<any> Packery).prototype['itemDragEnd'];
(<any> Packery).prototype['itemDragEnd'] = function () {
    var rtn = oldItemDragEnd.apply(this, arguments);
    this.dispatchEvent('dragEnd');
    return rtn;
};


export interface DashboardPackeryLayoutOptions extends BaseDashboardCategoryLayoutOptions {
    maxColumns: number
}


export class DashboardPackeryLayout extends BaseDashboardCategoryLayout {

    packery: Packery.Packery = null;
    $ = this.options.$el.find.bind(this.options.$el);

    private initialized = false;
    private initializing = false;

    constructor(protected options: DashboardPackeryLayoutOptions) {
        super(options);
    };

    initialize(): void {
        if (this.initialized || this.initializing) return;

        this.initializing = true;
        this.handlePageResize();
        this.buildLayout();
        this.initialized = true;
        this.initializing = false;
    }

    private buildLayout() {
        var $grid = <any>this.$('.category > .body');
        this.packery = new (<any> Packery)($grid.get(0), {
            itemSelector: '.widget',
            columnWidth: '.widget-sizer',
            percentPosition: true,
            initLayout: false,
            gutter: 0
        });

        // Init layout with saved positions
        var unpositioned = (<any>this.packery).initShiftLayout(
            this, this.getInitialWidgetPositions(), 'data-widget-id'
        );
        if (_.size(unpositioned)) {
            this.saveWidgetPositions();
        }

        // Make all grid-items draggable
        $grid.find('.widget').each((i, gridItem) => {
            var draggie = new Draggabilly(gridItem, {
                handle: '.drag-handle'
            });

            // Bind drag events to Packery
            this.packery.bindDraggabillyEvents(draggie);

        });

        // Save drag positions on drag event
        this.packery.on('dragEnd', () => {
            this.saveWidgetPositions();
            this.layout();
        });
    }

    getColumnIndexFromApproxPercentage(percentage) {
        var numCol = this.getNumberOfColumns();
        if (numCol <= 1) return 0;

        var breaks = {
            2: [0.2],
            3: [0.2, 0.5],
            4: [0.25 / 2, (0.25 + 0.5) / 2, (0.5 + 0.75) / 2],
            5: [0.1, 0.3, 0.5, 0.7],
            6: [(1 / 6) / 2, (1 / 6 + 2 / 6) / 2, (2 / 6 + 3 / 6) / 2, (3 / 6 + 4 / 6) / 2, (4 / 6 + 5 / 6) / 2]
        };

        for (var i = 0; i < breaks[numCol].length; i++) {
            if (percentage < breaks[numCol][i]) return i;
        }
        return numCol - 1;
    }

    getInitialWidgetPositions() {
        // Get saved dragged positions
        var columns = this.getNumberOfColumns();
        var initialPositions = this.options.model.get('widget_ui_positions');
        if (initialPositions) {
            initialPositions = JSON.parse(initialPositions);
            initialPositions = initialPositions[columns];
        }
        return initialPositions;
    }

    getNumberOfColumns() {
        var unit = this.$('.widget-sizer');

        // Make sure we're not dividing by 0 in case the category is currently not visible
        if (!unit.width()) {
            return 0
        }
        // Set number of columns, limiting by a maximum set in the category view
        return Math.min(Math.round(unit.parent().width() / unit.width()), this.options.maxColumns);
    }

    private handlePageResize() {
        $(document).resize(_.debounce(() => {
            if (!this.options.$el.is(':visible')) return;

            var columns = this.getNumberOfColumns();
            var initialPositions = this.options.model.get('widget_ui_positions');
            if (initialPositions) {
                initialPositions = JSON.parse(initialPositions);
                initialPositions = initialPositions[columns];
            }
            (<any>this.packery).initShiftLayout(this, initialPositions, 'data-widget-id');

        }, 200));
    }

    saveWidgetPositions() {
        // Save only if we have permission to do so
        if (!this.options.permissionCollection.canModifyDashboard(this.options.model.get("dashboard_id"))) return;

        // Wait for packery to be ready
        if (!this.packery) return;
        var columns = this.getNumberOfColumns();
        // Get current positions
        var currentPositions = this.options.model.get("widget_ui_positions");
        if (currentPositions) {
            currentPositions = JSON.parse(currentPositions);
        } else {
            currentPositions = {};
        }

        // Get drag positions from UI
        let newPositions = (<any>this.packery).getShiftPositions(this, "data-widget-id");

        // Filter out duplicates based on the 'attr' property
        const uniquePositions = new Map();
        newPositions.forEach((position) => {
            uniquePositions.set(position.attr, position); // Use 'attr' as a unique key
        });

        // Save positions to db after removing duplicates
        currentPositions[columns] = Array.from(uniquePositions.values());
        this.options.model.set("widget_ui_positions", JSON.stringify(currentPositions));

        App.Bus.trigger("dashboard:update:suspend");
        return $.when(this.options.model.save()).done(() => {
            App.Bus.trigger("dashboard:positions:saved");
            App.Bus.trigger("dashboard:update:resume");
        });
    }

    layout(viewsAddedOrRemoved?: boolean) {
        // Wait for packery to be ready
        if (!this.packery || !this.initialized || this.initializing) return;

        var allWidgets = this.$('.category > .body .widget');
        var items = this.packery.getItemElements();

        // Add new widgets
        _.each(allWidgets, (widget) => {
            if (!_.includes(items, widget)) {
                this.packery.appended(widget);

                // Add drag/drop events
                var draggie = new Draggabilly(widget, {
                    handle: '.drag-handle'
                });

                // Bind drag events to Packery
                this.packery.bindDraggabillyEvents(draggie);
            }
        });

        (<any>this.packery).initShiftLayout(this, this.getInitialWidgetPositions(), 'data-widget-id');
        if (viewsAddedOrRemoved) {
            this.saveWidgetPositions();
        }
    }

    isInitialized(): boolean {
        return this.initialized;
    }

    remove(): void {
        if (this.packery) this.packery.destroy();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/dashboard/DashboardPackeryLayout.ts